BaseHandler = App.loadClass "core::reports/BaseHandler"
DetailOutput = App.loadClass "core::reports/DetailOutput"

class exports.Audit_SubHandler extends BaseHandler

    init: (data) ->

        @layoutUrl          = 'backend/portal/audit/table'
        @excelUrl           = 'backend/portal/audit/excel'
        @filterUrl          = 'backend/portal/audit/filters'
        @saveUrl            = 'backend/portal/audit/save'
        @layoutSelector     = '#audit_container'
        @refreshNavHandler  = false

        @subHandlers =
            'View_Audit_Breadcrumb':
                'class': 'portal::handlers/audit/View_Audit_Breadcrumb'

        @defaultSub = 'View_Audit_Breadcrumb'

        #dataTableReport does not allow you to set the column withs like
        @currentOutput = new DetailOutput this, @parent, 800, {
            sAjaxSource: 'backend/portal/audit/output/detail'
        }

        #Default filters
        opt =
            "changed_by":
                opt:
                    key: data.data.users_id
                    value: data.data.user


        @setDefaultsAndRun(0, 5, 15, opt)


    afterLoadLayout: (selector, response) ->
        super()

        $(@layoutSelector).off ".chk-update"
        $(@layoutSelector).on "click.chk-update", ".chk-update", (e) =>
            saveData =
                'toUpdate':
                    'at_id': $(e.target).attr('id')

            $.post @saveUrl, saveData

        $(@layoutSelector).off ".summary"
        $(@layoutSelector).on "click.summary", ".summary, i", (e) =>
            id = $(e.target).closest('div').attr('data-at-id')
            handler = @createSubHandler(@defaultSub)
            if handler
                handler.init(id)


    refreshReport: () ->
        if $.contains(document, @parent.msg[0]) and @parent.msg.length isnt 0
            @parent.msg.message_writer('info', 'Running Report...')

        @filters = ko.toJSON @parent.filters.jsonize()

        opt =
            postOptions:
                query: @filters

        @loadLayout opt
